import { render, staticRenderFns } from "./BookmarkIcon.vue?vue&type=template&id=47a48bd2&"
import script from "./BookmarkIcon.vue?vue&type=script&lang=js&"
export * from "./BookmarkIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports